import { render, staticRenderFns } from "./TablePriceFacility.vue?vue&type=template&id=15a5198a&scoped=true"
import script from "./TablePriceFacility.vue?vue&type=script&lang=js"
export * from "./TablePriceFacility.vue?vue&type=script&lang=js"
import style0 from "./TablePriceFacility.vue?vue&type=style&index=0&id=15a5198a&prod&lang=scss"
import style1 from "./TablePriceFacility.vue?vue&type=style&index=1&id=15a5198a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5198a",
  null
  
)

export default component.exports